import { Target, Eye } from 'lucide-react';
import { Reveal } from '../components/Reveal';

export function About() {
  return (
    <section id="about" className="section">
      <div className="container about-grid">
        <Reveal>
          <span className="eyebrow">About Alpha One</span>
          <h2 className="section-title">
            Building a <span className="accent">decentralized future.</span>
            <br />
            Empowering global change.
          </h2>
          <div className="about-copy" style={{ marginTop: '1.5rem' }}>
            <p>
              Alpha One is a <strong>next-generation Web3 ecosystem</strong> built on
              transparency, innovation, and community. We empower individuals to grow, lead, and
              succeed in the digital economy through a sustainable and decentralized network.
            </p>
            <p>
              Our platform creates real opportunities, drives long-term value, and builds a
              global movement for a better tomorrow — powered end-to-end by the{' '}
              <strong>LDS Token</strong>.
            </p>
          </div>

          <div className="stat-strip">
            <div className="stat">
              <b>7</b>
              <span>Level Income Depth</span>
            </div>
            <div className="stat">
              <b>2</b>
              <span>Alpha Club Tracks (A / B)</span>
            </div>
            <div className="stat">
              <b>3</b>
              <span>Elite Ranks — Silver to Diamond</span>
            </div>
            <div className="stat">
              <b>24/7</b>
              <span>Auto Withdrawal Support</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mv-card">
            <div className="mv-icon">
              <Target size={20} />
            </div>
            <div>
              <h4>Mission</h4>
              <p>
                To build a secure, transparent, and community-driven Web3 ecosystem powered by
                blockchain innovation and the LDS Token economy — creating sustainable digital
                opportunities and long-term value through technology and trust.
              </p>
            </div>
          </div>
          <div className="mv-card">
            <div className="mv-icon">
              <Eye size={20} />
            </div>
            <div>
              <h4>Vision</h4>
              <p>
                To become a globally trusted decentralized Web3 ecosystem where blockchain
                technology empowers individuals, strengthens communities, and creates limitless
                opportunities for sustainable growth.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
